import { FC } from 'react';
import styles from './DefinitionList.module.scss';

export interface DefinitionItem {
  term: string;
  detail: string;
}

export interface DefinitionGroup {
  title: string;
  items?: DefinitionItem[];
  narrative?: string;
}

export interface DefinitionListProps {
  leftGroups: DefinitionGroup[];
  rightGroups: DefinitionGroup[];
}

export const DefinitionList: FC<DefinitionListProps> = ({
  leftGroups,
  rightGroups,
}) => {
  const renderGroup = (group: DefinitionGroup, index: number) => (
    <div key={`${group.title}-${index}`} className={styles.group}>
      <h4 className={styles.groupTitle}>{group.title}</h4>
      {group.items && group.items.length > 0 && (
        <dl className={styles.definitionList}>
          {group.items.map((item, idx) => (
            <div key={`${item.term}-${idx}`} className={styles.row}>
              <dt className={styles.term}>{item.term}</dt>
              <dd className={styles.detail}>{item.detail}</dd>
            </div>
          ))}
        </dl>
      )}
      {group.narrative && <p className={styles.narrativeText}>{group.narrative}</p>}
    </div>
  );

  return (
    <div className={styles.twoColumnGrid}>
      <div className={styles.column}>
        {leftGroups.map((g, i) => renderGroup(g, i))}
      </div>
      <div className={styles.column}>
        {rightGroups.map((g, i) => renderGroup(g, i))}
      </div>
    </div>
  );
};
